import { useToast } from 'context/providers/ToastProvider';
import useToken from 'hooks/useToken';
import React, { useEffect, useState } from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { useParams, useNavigate } from 'react-router-dom';

import ConfirmationModal from './lista-facturas/ConfirmationModal';

import BotonesAccion from './visualizacion-factura/BotonesAccion';
import ConceptosFactura from './visualizacion-factura/ConceptosFactura';
import CondicionesPago from './visualizacion-factura/CondicionesPago';
import DatosFactura from './visualizacion-factura/DatosFactura';
import HeaderFactura from './visualizacion-factura/HeaderFactura';
import InformacionGlobal from './visualizacion-factura/InformacionGlobal';
import DocumentosRelacionados from './visualizacion-factura/DocumentosRelacionados';
import PagosRelacionados from './visualizacion-factura/PagosRelacionados';
import OrdenesVinculadas from './visualizacion-factura/OrdenesVinculadas';
import SellosDigitales from './visualizacion-factura/SellosDigitales';

const VisualizacionFacturasEmitidas = () => {

    const { showErrorToast, showSuccessToast } = useToast();
    const { token, setToken } = useToken();
    const { id } = useParams();
    const navigate = useNavigate();

    const [receptor, setReceptor] = useState({});
    const [emisor, setEmisor] = useState({});
    const [facturaElectronica, setFacturaElectronica] = useState({});
    const [datosSellos, setDatosSellos] = useState({});
    const [conceptos, setConceptos] = useState([]);
    const [total, setTotal] = useState({});
    const [value, setValue] = useState('');
    const [informacionGlobal, setInformacionGlobal] = useState({
        periodicidad: null,
        mes: null,
        anio: null,
        existe: false
    });
    const [documentosRelacionados, setDocumentosRelacionados] = useState([]);
    const [pagosRelacionados, setPagosRelacionados] = useState([]);

    const [showModal, setShowModal] = useState(false);
    const [currentAction, setCurrentAction] = useState(false);
    const [isActive, setIsActive] = useState(null)
    const [ordenesVinculadas, setOrdenesVinculadas] = useState([]);

    /**
    * Se ejecuta una vez
    */
    useEffect(() => {
        ObtenerXML();
        obtenerPagosRelacionados(id);
    }, [id]);

    const obtenerPagosRelacionados = async (idFactura) => {
        try {
            const response = await fetch("/api/contabilidad/centro-xml/FacturasEmitidas/ObtenerPagosRelacionados", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idFacturaEmitida: idFactura })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    setPagosRelacionados(JSON.parse(data.detalles || '[]'));
                } else {
                    setPagosRelacionados([]);
                }
            }
        } catch (error) {
            console.error("Error al obtener pagos relacionados:", error);
        }
    };



    // Utilidad para formatear números en formato mexicano con dos decimales
    const formatNumberMX = (value) => {
        return new Intl.NumberFormat('es-MX', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
    };

    /**
    * Verifica si existen órdenes vinculadas a la factura
    */
    const verificarOrdenesVinculadas = async (idFacturaEmitida) => {
        try {
            const response = await fetch("/api/contabilidad/facturas/FacturaOrden/VerificarOrdenesVinculadas", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ idFacturaEmitida })
            });

            if (response.ok) {
                const data = await response.json();
                if (data.iResponseType === 1) {
                    setOrdenesVinculadas(JSON.parse(data.ordenes || '[]'));
                } else {
                    setOrdenesVinculadas([]);
                }
            } else {
                console.error("Error al verificar órdenes vinculadas:", response.status);
                setOrdenesVinculadas([]);
            }
        } catch (error) {
            console.error("Error en la petición de órdenes vinculadas:", error);
            setOrdenesVinculadas([]);
        }
    };


    /**
   * Funcion para mostrar datos de la tabla factura
   */
    const ObtenerXML = async () => {


        var objDataSend = {};

        objDataSend.idFacturaEmitida = id;


        console.log("Informacion enviada al endpoint", objDataSend)
        const response = await fetch("/api/contabilidad/centro-xml/FacturasEmitidas/obtenerXMLFacturaEmitida",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(objDataSend)
            })
            .catch((error) => {

                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            console.log("==== informacion Factura  ====");
            console.log("response: ", response);
            const data = await response.json();
            console.log("data: ", data);


            if (data.iResponseType == 1) {

                var ObjDetalles = JSON.parse(data.detalles);
                console.log(ObjDetalles, "detalles")

                setIsActive(ObjDetalles.table2[0].bIsActive)

                // Paso 2: Acceder a 'table2' y obtener el primer elemento (asumiendo que hay al menos uno)
                let vXMLString = ObjDetalles.table2[0].vXML;

                // Paso 3: Parsear 'vXML' que sigue siendo una cadena JSON
                let vXML = JSON.parse(vXMLString);
                console.log(vXML)
                let emisorA = vXML.Comprobante.Emisor;

                let emisor = ObjDetalles.table2[0].vRegimenFiscalEmisor;

                setEmisor({ ...emisorA, ...emisor, vRegimenFiscalEmisor: emisor });

                let receptor = vXML.Comprobante.Receptor;

                let comprobante = vXML.Comprobante;



                let complemento = vXML.Comprobante.Complemento.timbreFiscalDigital;
                let fechaOriginal = complemento.FechaTimbrado;

                const tfd = vXML.Comprobante.Complemento.timbreFiscalDigital;
                const cadenaOriginal = `||${tfd.version}|${tfd.UUID}|${tfd.FechaTimbrado}|${tfd.RfcProvCertif}|${tfd.SelloCFD}|${tfd.NoCertificadoSAT}||`;

                const infoGlobal = vXML?.Comprobante?.InformacionGlobal;

                if (infoGlobal) {
                    const periodicidad = infoGlobal?.Periodicidad || null;
                    const mes = infoGlobal?.Meses || null;
                    const anio = infoGlobal?.Año || null;

                    // ✅ Guardar en el state
                    setInformacionGlobal({
                        periodicidad,
                        mes,
                        anio,
                        existe: true
                    });


                } else {
                    // ❌ No existe nodo, reiniciar el state
                    setInformacionGlobal({
                        periodicidad: null,
                        mes: null,
                        anio: null,
                        existe: false
                    });

                }


                const cfdiRelacionados = vXML.Comprobante.CfdiRelacionados;
                setDocumentosRelacionados(cfdiRelacionados ? (Array.isArray(cfdiRelacionados) ? cfdiRelacionados : [cfdiRelacionados]) : []);


                let productos = vXML.Comprobante.Conceptos.Concepto;



                setConceptos(productos);


                /***************/
                /*Cuenta total factura*/
                /***************/

                let total = vXML.Comprobante.Total || 0;
                let subtotal = vXML.Comprobante.SubTotal || 0;

                let tasaOCuota = vXML.Comprobante.Impuestos?.Traslados?.Traslado?.[0]?.TasaOCuota || 0;
                let descuento = vXML.Comprobante.Descuento || null;



                /*let total = vXML.Comprobante.Impuestos.Traslados.Traslado[0];*/
                let traslados2 = vXML.Comprobante.Impuestos?.TotalImpuestosTrasladados || 0;
                let retenidos = vXML.Comprobante.Impuestos?.TotalImpuestosRetenidos || 0;




                /***************/
                /*TRASLADOS/
                /***************/
                let traslados = vXML.Comprobante.Impuestos?.Traslados?.Traslado;

                let TrasladoISR = null;
                let TrasladoIVA = null;
                let tieneIvaExento = false;

                if (Array.isArray(traslados)) {
                    traslados.forEach((tras) => {
                        if (tras.TipoFactor === 'Exento' && tras.Impuesto === '002') tieneIvaExento = true;
                        switch (tras.Impuesto) {
                            case '001': TrasladoISR = (TrasladoISR || 0) + parseFloat(tras.Importe || 0); break;
                            case '002': if (tras.TipoFactor !== 'Exento') TrasladoIVA = (TrasladoIVA || 0) + parseFloat(tras.Importe || 0); break;
                        }
                    });
                } else if (traslados) {
                    if (traslados.TipoFactor === 'Exento' && traslados.Impuesto === '002') tieneIvaExento = true;
                    switch (traslados.Impuesto) {
                        case '001': TrasladoISR = (TrasladoISR || 0) + parseFloat(traslados.Importe || 0); break;
                        case '002': if (traslados.TipoFactor !== 'Exento') TrasladoIVA = (TrasladoIVA || 0) + parseFloat(traslados.Importe || 0); break;
                    }
                }



                /***************/
                /*RETENCIONES/
                /***************/

                let retenciones = vXML.Comprobante.Impuestos?.Retenciones?.Retencion;

                let RetencionIVA = 0;
                let RetencionISR = 0;
                let RetencionIEPS = 0;

                if (Array.isArray(retenciones)) {
                    retenciones.forEach((ret) => {
                        switch (ret.Impuesto) {
                            case '001': RetencionISR += parseFloat(ret.Importe || 0); break;
                            case '002': RetencionIVA += parseFloat(ret.Importe || 0); break;
                            case '003': RetencionIEPS += parseFloat(ret.Importe || 0); break;
                        }
                    });
                } else if (retenciones) {
                    switch (retenciones.Impuesto) {
                        case '001': RetencionISR += parseFloat(retenciones.Importe || 0); break;
                        case '002': RetencionIVA += parseFloat(retenciones.Importe || 0); break;
                        case '003': RetencionIEPS += parseFloat(retenciones.Importe || 0); break;
                    }
                }

                /***************/
                /*RETENCIONES/
                /***************/

                // Formateo de los valores a formato con comas y puntos
                let formattedTotal = formatNumberMX(total);
                let formattedSubtotal = formatNumberMX(subtotal);
                let formattedTraslados = traslados ? formatNumberMX(traslados2) : null;
                let formattedTasaOCuota = formatNumberMX(tasaOCuota);
                let formattedDescuento = descuento > 0 ? formatNumberMX(descuento) : null;
                let formattedRetenidos = retenidos ? formatNumberMX(retenidos) : null;
                // Almacenar los valores formateados
                setTotal({
                    dTotal: formattedTotal,
                    dTotalSinFormato: total,
                    dSubtotal: formattedSubtotal,
                    dtrasladosImpuestos: formattedTraslados,
                    TasaOCuota: formattedTasaOCuota,
                    TasaOCuotaOriginal: tasaOCuota,
                    Descuento: formattedDescuento,
                    Retenidos: formattedRetenidos,
                    RetencionIVA: RetencionIVA ? formatNumberMX(RetencionIVA) : null,
                    RetencionISR: RetencionISR ? formatNumberMX(RetencionISR) : null,
                    RetencionIEPS: RetencionIEPS ? formatNumberMX(RetencionIEPS) : null,
                    TrasladoIVA: TrasladoIVA !== null ? formatNumberMX(TrasladoIVA) : null,
                    TrasladoISR: TrasladoISR !== null ? formatNumberMX(TrasladoISR) : null,
                    tieneIvaExento: tieneIvaExento
                });


                // cuando parseas y extraes del XML:
                setFacturaElectronica({
                    TipoDeComprobante: comprobante.TipoDeComprobante === "I"
                        ? 'I - Ingreso'
                        : comprobante.TipoDeComprobante === "E"
                            ? 'E - Egreso'
                            : 'P - Pago',
                    MetodoPago: comprobante.MetodoPago === "PUE" ? 'PUE - Pago en una sola exhibición' : 'PDD - Pago en parcialidades ',
                    FormaPago: ObjDetalles.table2[0].vClave,
                    Moneda: comprobante.Moneda,
                    LugarExpedicion: comprobante.LugarExpedicion,
                    Fecha: comprobante.Fecha,
                    Exportacion: comprobante.Exportacion === "01" ? '01 - No Aplica' : '',
                    CertificadoEmisor: comprobante.NoCertificado,
                    Serie: comprobante.Serie,
                    Folio: comprobante.Folio,
                    TipoDeCambio: comprobante.TipoCambio,
                    CondicionesDePago: comprobante.CondicionesDePago

                });





                setReceptor({
                    ...vXML.Comprobante.Receptor,
                    vUsoCFDI: ObjDetalles.table2[0].vUsoCfdi,
                    vRegimen: ObjDetalles.table2[0].vRegimenFiscal,
                    NumRegIdTrib: comprobante.Receptor.NumRegIdTrib,
                    ResidenciaFiscal: comprobante.Receptor.ResidenciaFiscal,
                    DomicilioFiscal: comprobante.Receptor.DomicilioFiscalReceptor

                });


                // cuando parseas y extraes del XML:
                setDatosSellos({
                    FechaTimbrado: fechaOriginal,
                    NoCertificadoSAT: complemento.NoCertificadoSAT,
                    RfcProvCertif: complemento.RfcProvCertif,
                    SelloCFD: complemento.SelloCFD,
                    SelloSAT: complemento.SelloSAT,
                    UUID: complemento.UUID,
                    version: complemento.version,
                    certificacionSat: cadenaOriginal
                });

                let last8 = complemento.SelloCFD.slice(-8);
                console.log(last8)

                setValue(`https://verificacfdi.facturaelectronica.sat.gob.mx/default.aspx?id=${complemento.UUID}&re=${emisorA.Rfc}&rr=${receptor.Rfc}&tt=${total}&fe=${last8}`);


                // Verificar órdenes vinculadas
                await verificarOrdenesVinculadas(id);


            } else {

                showErrorToast(data.vMessage);
            }

        }
        else {

            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";

            }

        }
    };



    /**
    * Funcion para abrir modal
    */
    const handleOpenModal = (action) => {
        setCurrentAction(action);
        setShowModal(true);
    };

    /**
    * Funcion cerrar modal
    */
    const handleCloseModal = () => {
        setShowModal(false);
        setCurrentAction(null);
    };


    /**
    * Funcion para manejar el tipo de confrmacion
    */
    const handleConfirmAction = async () => {
        try {
            if (currentAction === 'eliminar') {
                await eliminarFactura();
                setShowModal(false);
            } else if (currentAction === 'cancelar') {
                await cancelarFactura();
                setShowModal(false);
            } else if (currentAction === 'cancelarSAT') {
                // Para cancelar en SAT, primero cerramos el modal de confirmación
                // y abrimos el modal de motivo
                setShowModal(false);
            }
        } catch (error) {
            console.error(`Error al ${currentAction} la factura:`, error);
        }
    };


    /**
    * Funcion para eliminar factura definitivamente
    */
    const eliminarFactura = async () => {

        var objDataSend = {};

        objDataSend.idFacturaEmitida = id;

        //console.log("Informacion enviada al endpoint",data)
        const response = await fetch("/api/contabilidad/centro-xml/FacturasEmitidas/EliminaFactura",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(objDataSend)
            })
            .catch((error) => {

                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            const data = await response.json();
            console.log(data);

            if (data.iResponseType == 1) {

                showSuccessToast(data.vMessage);

                navigate("/contabilidad/centro-xml/facturas-emitidas");
            } else {

                showErrorToast(data.vMessage);
            }

        } else {

            showErrorToast(response.status + ' ' + response.statusText);

        }
    }


    /**
    * Funcion para cancelar factura
    */
    const cancelarFactura = async () => {


        var objDataSend = {};

        objDataSend.idFacturaEmitida = id;
        //console.log("Informacion enviada al endpoint",data)
        const response = await fetch("/api/contabilidad/centro-xml/FacturasEmitidas/CancelaFactura",
            {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(objDataSend)
            })
            .catch((error) => {

                showErrorToast('Hubo un problema con la peticion Fetch:' + error);
                console.log('Hubo un problema con la peticion Fetch:' + error);

            });

        if (response.ok) {
            const data = await response.json();
            console.log(data);

            if (data.iResponseType == 1) {

                showSuccessToast(data.vMessage);

                setIsActive(false);


            } else {

                showErrorToast(data.vMessage);
            }

        } else {

            showErrorToast(response.status + ' ' + response.statusText);

        }
    };



    // Función para recargar la factura después de cancelar en SAT
    const refreshFactura = async () => {
        await ObtenerXML();
        await obtenerPagosRelacionados(id);
    };

    return (
        <>
            <Container fluid className='contenido-principal'>
                <Row className="grilla-principal" >
                    <Col xs={12} md={12} lg={12} xlg={12}>
                        <Card className="mb-4"  >
                            <Card.Body>
                                <div className="clearfix"></div>
                                <br />


                                <div className='div-content-formulario'>
                                    <HeaderFactura
                                        isActive={isActive}
                                        ordenesVinculadas={ordenesVinculadas}
                                        idFactura={parseInt(id)}
                                        vUUIDFactura={datosSellos?.UUID}
                                        dFechaEmision={facturaElectronica?.Fecha}
                                        vRfcEmisor={emisor?.Rfc}
                                    />


                                    <DatosFactura emisor={emisor} receptor={receptor} facturaElectronica={facturaElectronica} />

                                    <InformacionGlobal informacionGlobal={informacionGlobal} />
                                    <DocumentosRelacionados documentos={documentosRelacionados} tipoFactura="emitida" />
                                    <PagosRelacionados pagos={pagosRelacionados} totalFactura={total?.dTotalSinFormato} />

                                    <CondicionesPago facturaElectronica={facturaElectronica} />


                                    <ConceptosFactura conceptos={conceptos} total={total} facturaElectronica={facturaElectronica} />


                                    <OrdenesVinculadas ordenesVinculadas={ordenesVinculadas} />


                                    <SellosDigitales datosSellos={datosSellos} value={value} />


                                    <BotonesAccion
                                        isActive={isActive}
                                        handleOpenModal={handleOpenModal}
                                        datosSellos={datosSellos}
                                        emisor={emisor}
                                        receptor={receptor}
                                        total={total?.dTotalSinFormato}
                                        refreshFactura={refreshFactura}
                                    />
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <ConfirmationModal
                    show={showModal}
                    onHide={handleCloseModal}
                    onConfirm={handleConfirmAction}
                    action={currentAction}
                    IsActive={isActive}
                    message={`¿Estás seguro de que deseas ${currentAction} esta factura?`}
                    title={`Confirmar ${currentAction === 'eliminar' ? 'eliminación' : 'cancelación'}`}
                />

            </Container>
        </>
    );
};

export default VisualizacionFacturasEmitidas;